import { Card, CardContent } from '@/components/base/Card';
import avatarPerson from '@/assets/images/avatar-person.svg';
import type { RegistrationInfo } from '@/ayurveda/types/ayurveda';

export interface RegistrationCardProps {
  registration?: RegistrationInfo | null;
}

export function RegistrationCard({ registration }: RegistrationCardProps) {
  return (
    <Card padding="none" className="shrink-0 rounded-[24px] border-white bg-white">
      <CardContent className="flex flex-col gap-3 p-3">
        <h2 className="font-serif text-[calc(18px*var(--app-scale))] font-normal leading-[24px] text-[#3C4F1E]">
          Patient Information
        </h2>
        <div className="flex items-center gap-2.5 rounded-2xl bg-[#F8F8F1] p-3">
          <div className="relative h-[52px] w-[52px] flex-shrink-0 overflow-hidden rounded-full bg-[#D9D9D9]">
            <img
              src={avatarPerson}
              alt=""
              className="absolute left-[13px] top-[13px] h-[25px] w-[25px]"
              aria-hidden="true"
            />
          </div>
          <div className="flex flex-1 flex-col font-hanken text-base leading-6 text-[#585859]">
            {/* <p>
              <span className="font-medium">OP No.:</span> {registration?.opNo || '—'}
            </p> */}
            <p>
              <span className="font-medium">Legal Name:</span> {registration?.legalName || '—'}
            </p>
            <p className="whitespace-pre-wrap">
              <span className="font-medium">Age:</span> {registration?.age || '—'}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
